module.exports = __webpack_public_path__ + "img/appBrand--ax-full.f11d6652.svg";